import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BotscriptEditorCombinedComponent } from 'src/app/shared/components/botscript-editor-combined/botscript-editor-combined.component';
import { GotoBlocklyDirective } from 'src/app/shared/directives/goto-blockly.directive';
import { BlockSearchService } from 'src/app/shared/services/block-search.service';
import { BlocklyStorageService } from 'src/app/shared/services/blockly-storage.service';
import { EditorItemsService } from 'src/app/shared/services/editor-items.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { StageAdminService } from '@shared-angular/services/stage-admin.service';
import { FullscreenLayoutingService } from '../blockly-tab-fullscreen/fullscreen-layouting.service';
import { ButtonModule } from "primeng/button";

@Component({
  selector: 'app-blockly-tab',
  imports: [RouterLink, NgClass, NgTemplateOutlet,
    BotscriptEditorCombinedComponent,
    GotoBlocklyDirective,
    ButtonModule
  ],
  templateUrl: './blockly-tab.component.html',
  styleUrl: './blockly-tab.component.scss'
})
export class BlocklyTabComponent implements OnInit {
  public searchMode: boolean = false;
  @ViewChild('editor', { static: false }) public editor?: BotscriptEditorCombinedComponent;
  constructor(
    public rss: RouteShareService,
    public stagesService: StageAdminService,
    public blockyStorage: BlocklyStorageService,
    public editorItemService: EditorItemsService,
    public fullscreenLayout: FullscreenLayoutingService,
    public search: BlockSearchService
  ) { }

  public ngOnInit(): void {
    if (!this.rss.editorItem) {
      this.editorItemService.seletItem(this.rss.editorItems.global, 'JS Global');
    }
  }

  public activateSearch(input: HTMLInputElement) {
    this.searchMode = true;
    setTimeout(() => {
      input.focus();
    });
  }

  public leaveSearch() {
    this.searchMode = false;
    this.search.cancle();

  }
}
